import { Expose, Type, Exclude } from 'class-transformer';

import { SnUser } from '@lib/api/entities';
import { Plunk } from '@lib/common/decorators';
import { SnModel } from '@lib/common/models';

import { SnLprHotList } from './lpr-host-list';

export class SnLprObject extends SnModel {
  @Expose()
  public id: any;

  @Expose()
  @Type(() => SnLprHotList)
  @Plunk('id', { toPlainOnly: true })
  public lprHotlist: SnLprHotList;

  @Expose({ name: 'updatedTimestamp' })
  @Type(() => Date)
  @Exclude({ toPlainOnly: true })
  public updatedAt: Date;

  @Expose({ name: 'createdTimestamp' })
  @Type(() => Date)
  @Exclude({ toPlainOnly: true })
  public createAt: Date;

  @Expose({ name: 'expiresTimestamp' })
  @Type(() => Date)
  @Exclude({ toPlainOnly: true })
  public expiresAt: Date;

  @Expose()
  public plate: string;

  @Expose()
  public properties: any;

  @Expose()
  public group: string;

  @Expose()
  public status: string;

  @Expose()
  public reason: string;

  @Expose()
  @Type(() => SnUser)
  public createdBy: SnUser;

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }
}
